module.exports = __webpack_public_path__ + "img/modal-gray.aae3440a.svg";